var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9055423_bxs_edit_icon (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3177 2.68262L29.3177 6.68262L26.2683 9.73328L22.2683 5.73328L25.3177 2.68262ZM10.667 21.3333H14.667L24.383 11.6173L20.383 7.61728L10.667 17.3333V21.3333Z",
    fill: "#163E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.3333 25.3333H10.8773C10.8427 25.3333 10.8067 25.3467 10.772 25.3467C10.728 25.3467 10.684 25.3347 10.6387 25.3333H6.66667V6.66667H15.796L18.4627 4H6.66667C5.196 4 4 5.19467 4 6.66667V25.3333C4 26.8053 5.196 28 6.66667 28H25.3333C26.0406 28 26.7189 27.719 27.219 27.219C27.719 26.7189 28 26.0406 28 25.3333V13.776L25.3333 16.4427V25.3333Z",
    fill: "#163E6E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.96f5ba0d3d5920f4415856eb21be09a7.svg";
export { ForwardRef as ReactComponent };